module.exports = __webpack_public_path__ + "img/ring_y_i_1_0@2x.6fdbcd7b.png";